import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Ecosystem() {
  const { t } = useLanguage();
  return (
    <section
      id="ecosystem"
      data-testid="ecosystem-section"
      className="py-24 md:py-32 bg-[#0F0F0F] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="max-w-3xl">
          <p className="overline">{t.ecosystem.overline}</p>
          <h2 className="font-display uppercase mt-4 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            {t.ecosystem.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/65 max-w-2xl">
            {t.ecosystem.subtitle}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 relative">
          {t.ecosystem.steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`ecosystem-step-${i}`}
              className="bg-[#0A0A0A] p-8 md:p-10 min-h-[280px] flex flex-col justify-between relative"
            >
              <div>
                <div className="flex items-center gap-4">
                  <span className="font-mono-plex text-redflag text-sm">
                    {s.tag}
                  </span>
                  <span className="font-mono-plex text-[10px] uppercase tracking-widest text-white/40">
                    {s.role}
                  </span>
                </div>
                <h3 className="mt-6 font-display uppercase text-3xl md:text-4xl tracking-tight text-white">
                  {s.name}
                </h3>
              </div>
              <div>
                <p className="text-sm md:text-base text-white/65 leading-relaxed">
                  {s.desc}
                </p>
                {i < t.ecosystem.steps.length - 1 && (
                  <ArrowRight
                    size={20}
                    className="hidden md:block absolute -right-3 top-1/2 -translate-y-1/2 z-10 text-redflag bg-[#0F0F0F] px-1 box-content"
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
